<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏 -->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索：
                        <el-input placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option
                                        v-for="item in keywordList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-input>
                    </div>
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV">
                        <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true"></i>
                    </el-button>
                </div>
            </div>
            <div v-show="showFV" class="yx-flex-h-start" style="margin-top: 15px;">
                <div>
                    状态：
                    <el-select v-model="searchVal.agentStatId" placeholder="服务商状态" size="mini" clearable
                               style="width: 150px;margin-right: 15px;">
                        <el-option
                                v-for="item in this._enums.AgentStatusEnum"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div v-if="this.$store.state.currentHr.agentLevel===0">
                    等级：
                    <el-select v-model="searchVal.agentLevelId" placeholder="服务商等级" size="mini" clearable
                               style="width: 150px;margin-right: 15px;">
                        <el-option
                                v-for="item in _enums.AgentLevelEnum"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div v-if="this.$store.state.currentHr.agentLevel===0">
                    推荐人：
                    <el-select v-model="searchVal.agentPid" placeholder="服务商来源" size="mini" filterable  clearable
                               style="width: 150px;margin-right: 15px;">
                        <el-option
                                v-for="item in agentFromList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>

            </div>
            <div class="yx-flex-h-start" style="margin-top: 15px;">
                <el-button type="danger" icon="el-icon-plus" @click="viewAdd">新增服务商</el-button>
                <!-- 推荐人、等级、状态 单独控制权限，不在编辑里更新
                <el-button type="danger" icon="el-icon-user" @click="" :disabled="disableBtn">设置推荐人</el-button>
                <el-dropdown trigger="click" @command="changeAgentLevel">
                    <el-button type="danger" icon="el-icon-star-off" @click="" :disabled="disableBtn">
                        设置等级 <i class="el-icon-arrow-down el-icon--right" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item,index) in agentLevels" :key=index :command="item.id">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                -->
                <el-dropdown trigger="click" @command="changeAgentStatus">
                    <el-button v-if="this.$store.state.currentHr.agentLevel===0" type="danger" icon="el-icon-setting" @click="" :disabled="disableBtn" style="margin-left: 15px;">
                        更新状态 <i class="el-icon-arrow-down el-icon--right" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item,index) in this.agentStatusOptx" :key=index :command="item.id" :disabled="item.id===1">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

            </div>
        </div>

        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :data="agents"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    @selection-change="handleSelectionChange"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%">
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column prop="agentCode" label="服务商编号" width="100"></el-table-column>
                <el-table-column prop="agentName" label="服务商名称" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态" width="100"  align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.agentStatusId===2">{{_enums.AgentStatusEnum.getNameById(scope.row.agentStatusId)}}</span>
                        <el-tag v-else :type="scope.row.agentStatusId===1?'danger':scope.row.agentStatusId===5?'warning':'info'" effect="dark">{{_enums.AgentStatusEnum.getNameById(scope.row.agentStatusId)}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="agentLevelId" label="等级" width="100" align="center">
                    <template slot-scope="scope">
                        <div class="yx-flex-h-center">
                            <div class="yx-flex-v">
                                <el-rate :max="1" v-if="scope.row.agentLevelId===1" :value="1" :colors="['#FF0000', '#FF0000', '#FF0000']" />
                                <el-rate :max="1" v-else-if="scope.row.agentLevelId===2" :value="1" :colors="['#ffc000', '#ffc000', '#ffc000']" />
                                <span>{{ _enums.AgentLevelEnum.getNameById(scope.row.agentLevelId) }}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="agentPidName" label="推荐人" width="100" show-overflow-tooltip></el-table-column>
                <!--
                <el-table-column prop="legalPerson" label="法人" width="100"></el-table-column>
                -->
                <el-table-column prop="linkMan" label="负责人" width="100"></el-table-column>
                <el-table-column prop="linkPhone" label="联系电话" width="100"></el-table-column>
                <el-table-column prop="cityIdName" label="城市" width="100"></el-table-column>
                <el-table-column v-if="user.agentIdS==='1'" prop="accTotal" label="已入账" width="100"></el-table-column>
                <el-table-column v-if="user.agentIdS==='1'" prop="accBalance" label="账户余额" width="100"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <!--
                        <el-button type="info" plain size="mini" style="padding: 5px" @click="viewEdit(scope.row)">编辑</el-button>
                        -->
                        <el-button type="primary" plain size="mini" style="padding: 5px" @click="viewDetail(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="width: 1px" />
            <!--
            <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
            -->
            <el-pagination
                    background
                    :current-page.sync="page"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="sizes, prev, pager, next, jumper, ->, total, slot"
                    :total="total">
            </el-pagination>
        </div>

        <el-drawer
                :title=agentInfo.agentName
                :with-header="false"
                :visible.sync="drawer"
                :show-close=false
                size = "60%"
                direction="rtl">
            <div style="padding: 0 10px 30px 10px">
                <el-table :data="[agentInfo]" style="padding-left: 0px">
                    <el-table-column prop="agentCode" label="编号" />
                    <el-table-column prop="agentLevelId" label="等级" >
                        <template slot-scope="scope">
                            {{ _enums.AgentLevelEnum.getNameById(scope.row.agentLevelId) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" >
                        <template slot-scope="scope">
                            {{_enums.AgentStatusEnum.getNameById(scope.row.agentStatusId)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" />
                </el-table>
            </div>

            <AgentDetailDiv :key="agentInfo.id" v-bind:inAgentInfo="agentInfo"></AgentDetailDiv>
        </el-drawer>

        <AgentBaseDlg :key="keyCompDlg" v-bind:inOptType="dlgModel" v-bind:inAgentInfo="agentInfo" v-bind:outDlgClosed.sync="dlgClosed"/>

    </div>

</template>

<script>

    import {
        URL_AGENT_NATURES,
        URL_AGENT_LEVELS,
        URL_AGENT_STATUSES,
        URL_BANK_ACC_TYPES,
        URL_AREAS_PROV_CITY,
        URL_AGENT_FROMS
    } from "../../utils/cons";
    import AreaSelect from "../../components/pub/AreaSelect";
    import BankSelect from "../../components/pub/BankSelect";
    import {deepClone, findIdxByKeyValue} from '../../utils/datatool'
    import AgentDetailDiv from "../../components/agent/AgentDetailDiv";
    import AgentBaseDlg from "../../components/agent/AgentBaseDlg";

    export default {
        name: "AgentInfo",
        components: {AgentBaseDlg, AgentDetailDiv, AreaSelect,BankSelect},
        data() {
            return {
                drawer: false,
                disableBtn: true,
                dlgClosed: false,
                dlgModel: '',
                keyCompDlg: null,
                titleDlg: '',
                showFV: false,
                loading: false,
                total: 0,
                page: 1,
                size: 10,
                agents: [],
                agentStatusOptx: [],
                agentFromList: [],
                agentInfo: {
                    id: null,
                    agentCode: null,
                    agentName: null,
                    shortName: null,
                    provId: '',
                    provIdName: '',
                    cityId: '',
                    cityIdName: '',
                    distId: '',
                    distIdName: '',
                    addr: null,
                    tel: null,
                    linkMan: null,
                    linkPhone: null,
                    linkMail: null,
                    licenseCode: null,
                    licensePhoto: null,
                    legalPerson: null,
                    legalPhone: null,
                    legalIdcardNo: null,
                    legalIdcardPhoto: null,
                    contractNo: null,
                    contractBeg: null,
                    contractEnd: null,
                    agentFee: null,
                    recvAgentFee: null,
                    stlBankCnapsCode: null,
                    settleCnaps: {cnapsCode:null,cnapsName:null},
                    stlAccNo: null,
                    stlAccIdcardNo: null,
                    stlAccName: null,
                    stlAccPhone: null,
                    agentLevelId: null,
                    agentLevel: {id:null,name:null},
                    agentNatureId: null,
                    agentNature: {id:null,name:null},
                    stlAccTypeId: null,
                    settleAccType: {id:null,name:null},
                    agentStatusId: null,
                    agentStatus: {id:null,name:null},
                    agentPid: null,
                    agentPidName: null,
                    remark: null,
                    sysName: null,
                    sysUserName: null
                },
                cityList:[],
                keywordList: [
                    {id:"agentName",name:"服务商名称"},
                    {id:"agentCode",name:"服务商编号"},
                    {id:"linkPhone",name:"联系电话"}
                    ],
                agentLevels: [],
                agentNatures: [],
                settleAccTypes: [],
                multipleSelection: [],
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                    agentStatId: null,
                    agentLevelId: null,
                    agentPid: null
                }
            }
        },
        watch: {
            dlgClosed: {
                handler: function (val) {
                    if (this.dlgClosed === true) {
                        this.initAgents();
                    }
                }
            },
        },
        computed: {
            user() {
                return this.$store.state.currentHr;
            }
        },
        mounted() {
            // console.log("this.$store.state.currentHr", JSON.stringify(this.$store.state.currentHr))
            this.initAgents();
            this.getRequest(URL_AGENT_LEVELS).then(resp => { if (resp) this.agentLevels = resp.data });
            this.getRequest(URL_AGENT_NATURES).then(resp => { if (resp) this.agentNatures = resp.data });
            this.getRequest(URL_BANK_ACC_TYPES).then(resp => { if (resp) this.settleAccTypes = resp.data });
            this.getRequest(URL_AREAS_PROV_CITY).then(resp => { if (resp) this.cityList = resp.data  });
            this.getRequest(URL_AGENT_FROMS).then(resp => { if (resp) this.agentFromList = resp.data  });
        },
        methods: {
            viewAdd() {
                this.dlgModel = 'INS';
                this.keyCompDlg = Date.now();
                this.dlgClosed = false;
            },
            viewEdit(data) {
                this.dlgModel = 'UPD';
                this.agentInfo = deepClone(data);
                this.keyCompDlg = Date.now();
                this.dlgClosed = false;
            },
            viewDetail(data) {
                Object.assign(this.agentInfo, data);
                this.drawer = true;
            },
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.page = 1;
                this.initAgents();
            },
            changeAgentStatus(command) {
                let commandName = this._enums.AgentStatusEnum.getDescById(command)

                let ids = [];
                let names = '';
                this.multipleSelection.forEach(item => {
                    ids.push(item.id);
                    names += item.agentName + '，';
                });
                names = names.substring(0, names.length-1);
                this.$confirm('<' + commandName + '>服务商【' + names + '】？',
                    '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {

                    this.putRequest("/agent/updateAgentStat" + "?statusId=" + command + "&ids=" + ids).then(resp => {
                        if (resp) {
                            this.initAgents();
                        }
                    });

                }).catch(() => {
                    this.$message({ type: 'info', message: '已取消' });
                });
            },
            changeAgentLevel(command) {
                let ids = [];
                this.multipleSelection.forEach(item => { ids.push(item.id); });
                this.putRequest("/agent/updateAgentLevel" + "?levelId=" + command + "&ids=" + ids).then(resp => {
                    if (resp) {
                        this.initAgents();
                    }
                });
            },
            changeAgentPid(command) {
                let ids = [];
                this.multipleSelection.forEach(item => { ids.push(item.id); });
                this.putRequest("/agent/updateAgentPid" + "?pid=" + command + "&ids=" + ids).then(resp => {
                    if (resp) {
                        this.initAgents();
                    }
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if(this.multipleSelection.length>0) {
                    this.disableBtn = false;
                    this.multipleSelection.forEach(item => {
                        if (item.agentStatusId!==this._enums.AgentStatusEnum.审核中.id) {
                            this.agentStatusOptx = this._enums.AgentStatusOpt2Enum
                        } else {
                            this.agentStatusOptx = this._enums.AgentStatusOpt1Enum
                        }
                    })
                }
                else {
                    this.disableBtn = true;
                }
            },
            initAgents() {
                this.loading = true;
                let url = '/agent/agentInfo?page=' + this.page + '&size=' + this.size;


                if (this.searchVal.keywordMethod && this.searchVal.keyword) {
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                }
                if (this.searchVal.agentLevelId) {
                    url += '&agentLevelId=' + this.searchVal.agentLevelId;
                }
                if (this.searchVal.agentStatId) {
                    url += '&agentStatusId=' + this.searchVal.agentStatId;
                }
                if (this.searchVal.agentPid) {
                    url += '&agentPid=' + this.searchVal.agentPid;
                }

                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.agents = resp.data;
                        this.total = resp.total;
                    }
                })
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initAgents();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initAgents();
            },
            exportData() {
            }
        }

    }
</script>

<style scoped>
</style>
